import { render, staticRenderFns } from "./TreeFolder.vue?vue&type=template&id=76874106&scoped=true&"
import script from "./TreeFolder.vue?vue&type=script&lang=js&"
export * from "./TreeFolder.vue?vue&type=script&lang=js&"
import style0 from "./TreeFolder.vue?vue&type=style&index=0&id=76874106&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76874106",
  null
  
)

export default component.exports